import { T } from '@agos/shared'
import { BadgeEuro, CheckCircle2 } from 'lucide-react'

/**
 * One channel's consent in the customer drawer - e-mail, SMS and, since §9.735, push.
 *
 * Moved out of `MarketingCustomersPage.tsx` unchanged when the push row joined the two, so the three rows are one
 * component rather than two copies of a button and a look-alike.
 */
export function ConsentRow({
  label,
  detail,
  checked,
  disabled,
  onChange,
  testId,
}: {
  label: string
  detail: string
  checked: boolean
  disabled: boolean
  onChange: (next: boolean) => void
  testId: string
}) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      disabled={disabled}
      className="w-full flex items-center justify-between gap-3 px-3 py-2.5 rounded-xl border border-border bg-muted/40 text-left disabled:opacity-60"
      data-consent-row={testId}
    >
      <span className="min-w-0">
        <span className="block text-sm font-medium">{label}</span>
        <span className="block text-[11px] text-muted-foreground truncate">{detail}</span>
      </span>
      {checked ? (
        <CheckCircle2 className="w-6 h-6 text-emerald-500 shrink-0" />
      ) : (
        <BadgeEuro className="w-6 h-6 text-muted-foreground shrink-0 rotate-45 opacity-0" />
      )}
      {!checked && <span className="text-xs font-bold text-muted-foreground shrink-0"><T>vypnuté</T></span>}
    </button>
  )
}
